import { render, staticRenderFns } from "./DownloadCenterButton.vue?vue&type=template&id=316832b8&scoped=true"
import script from "./DownloadCenterButton.vue?vue&type=script&lang=js"
export * from "./DownloadCenterButton.vue?vue&type=script&lang=js"
import style0 from "./DownloadCenterButton.vue?vue&type=style&index=0&id=316832b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316832b8",
  null
  
)

export default component.exports